export const formatAdminTransferRate = (bps) => {
  if (typeof bps !== "number" || !Number.isFinite(bps) || bps <= 0) {
    return null;
  }

  const units = ["B/s", "KB/s", "MB/s", "GB/s"];
  let value = bps;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  return `${value.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
};
